import { InjectionToken } from '@angular/core';

export const StorageInjectionToken = new InjectionToken<Storage>('STORAGE');
